import { Component, OnDestroy, Inject, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { BreadcrumbService } from './app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { DOCUMENT } from '@angular/common';
import { FavoriEntite } from './entites/favori';
import { ProfilService } from './services/profil-service';
import { HistoriqueEntite } from './entites/historique';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { estEnvironnementDeTest } from 'src/environments/environnement-test';
import { BreadcrumbPipe } from './pipes/breadcrumb.pipe';
import { ThemeService, ThemeOption } from './services/theme.service';
import { SupabaseService } from "./services/supabase.service";
import { MessageService } from 'primeng/api';
import { NotificationService } from "./services/notification-service";
import { Notification } from "./entites/notification";
import { RapportService } from "./services/rapport-service";
 
@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    providers: [BreadcrumbPipe]
})
export class AppTopBarComponent implements OnDestroy, OnInit {

    subscription: Subscription;

    items: MenuItem[];
    home: MenuItem;
    userItems: MenuItem[];
    favorisItems: MenuItem[];
    historiquesItems: MenuItem[];
    notificationsItems: MenuItem[];

    favoris: FavoriEntite[] = [];
    historiques: HistoriqueEntite[] = [];
    notifications: Notification[] = [];
    unreadCount: number = 0;

    nomUtilisateur: string;

    afficherAlerteDev: boolean = false;

    url: string;

    estEnModeImitation: boolean = false;
    nomEmployeImite: string = '';

    supprimeLoading = false;
    supprimeToutLoading = false;
    marquerToutLuLoading = false;

    constructor(
        public profilService: ProfilService,
        public notificationService: NotificationService,
        public routerService: Router,
        public breadcrumbService: BreadcrumbService,
        public app: AppComponent,
        public appMain: AppMainComponent, location: Location, 
        public supabaseService: SupabaseService,
        public themeService: ThemeService,
        private messageService: MessageService,
        private rapportService: RapportService,
        @Inject(DOCUMENT) private doc: Document) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
    }

    ngOnInit() {
        console.log('AppTopBarComponent ngOnInit');

        this.url = environment.urlBase;

        this.afficherAlerteDev = estEnvironnementDeTest(environment);

        this.nomUtilisateur = `${this.profilService.ProfilCourant().prenom} ${this.profilService.ProfilCourant().nom}`;
        
        // Vérifier le mode imitation
        this.estEnModeImitation = this.profilService.EstEnModeImitation();
        if (this.estEnModeImitation && this.profilService.Profil()?.employeImite) {
            const employeImite = this.profilService.Profil().employeImite;
            this.nomEmployeImite = `${employeImite.prenom} ${employeImite.nom}`;
        }
        
        this.obtenirFavoris();
        this.obtenirHistorique();
        
        this.notificationService.notifications$.subscribe(notifications => {
            this.notifications = notifications;
        });

        this.notificationService.unreadCount$.subscribe(count => {
            this.unreadCount = count;
        });

        this.genererMenus();

        this.profilService.changementFavoris.subscribe(x => {
            this.obtenirFavoris();
        });

        this.profilService.changementHistorique.subscribe(x => {
            this.obtenirHistorique();
        });
    }

    genererMenus() {
        this.home = { icon: 'pi pi-home', routerLink: '/' };
        this.userItems = [
            { label: 'Mon Profil', icon: 'pi pi-user', command: () => this.naviguer(`/employe/${this.profilService.ProfilCourant().employeId}`) },
            { label: 'Recharger', icon: 'pi pi-refresh', command: () => this.recharger() },
            { label: 'Paramètres', icon: 'pi pi-cog', routerLink: `/employe/${this.profilService.ProfilCourant().employeId}`, queryParams: { tabIndex: 4 } },
            { label: 'Déconnexion', icon: 'pi pi-sign-out', command: () => this.supabaseService.signOut() }
        ];

    }

    recharger() {
        this.routerService.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                this.routerService.navigate(['/']));
    }

    obtenirFavoris() {
        this.profilService.ObtenirFavoris(this.profilService.ProfilCourant().employeId).then(x => {
            this.favoris = x;
        });
    }

    supprimerFavori(favoriId: number) {
        this.profilService.supprimerFavori(favoriId);
    }

    naviguer(url: string) {
        this.routerService.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                this.routerService.navigate([url]));
    }

    /// <summary>
    /// Navigates back in the browser history
    /// </summary>
    goBack() {
        window.history.back();
    }

    naviguerNotification(notification: Notification) {
        if (!notification.indLu) {
            this.notificationService.marquerCommeLu(notification.notificationDestinataireId).subscribe();
        }

        const viewUrl = this.rapportService.resolveNotificationViewUrl(notification.donneesPersonnalisees);
        if (viewUrl) {
            window.open(viewUrl, '_blank');
        }
    }

    obtenirHistorique() {
        this.historiques = this.profilService.obtenirHistorique();
    }

    supprimerHistorique() {
        this.profilService.viderHistorique();
    }

    marquerToutLu() {
        this.marquerToutLuLoading = true;
        this.notificationService.marquerToutesCommeLu().subscribe({
            next: () => {
                this.marquerToutLuLoading = false;
            },
            error: () => {
                this.marquerToutLuLoading = false;
            }
        });
    }

    supprimerNotification(notification: Notification) {
        this.supprimeLoading = true;
        this.notificationService.supprimer(notification.notificationDestinataireId).subscribe({
            next: () => {
                this.supprimeLoading = false;
            },
            error: () => {
                this.supprimeLoading = false;
            }
        });
    }

    effacerTout() {
        this.supprimeToutLoading = true;
        this.notificationService.supprimerToutes().subscribe({
            next: () => {
                this.supprimeToutLoading = false;
            },
            error: () => {
                this.supprimeToutLoading = false;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    sanitizeUrl(str: string): string {
        // Remove special characters and replace spaces with hyphens
        return str
            .toLowerCase()
            .trim()
            .normalize('NFD') // Decompose accented characters
            .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
            .replace(/[^a-z0-9\s-]/g, '') // Remove special chars except spaces and hyphens
            .replace(/[\s]+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-'); // Remove consecutive hyphens
    }

    arreterImpersonation() {
        this.profilService.ArreterImpersonation().subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Mode imitation arrêté. Vos rôles normaux ont été restaurés.' });
                window.location.reload();
            },
            error: (error) => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: error.error?.message || 'Une erreur est survenue lors de l\'arrêt de l\'impersonation' });
            }
        });
    }
}
